import FileUploader from 'components/UploaderAndDownloader/FileUploader';
import React, { useCallback, useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { ICreateFirmwareContext, CreateFirmwareContext } from '../../../createFirmwareState/createFirmwareContext';
import { useAdditionalValidation } from 'components/WithAdditionalValidation/useAdditionalValidation';
import { postMediaFile } from 'backend/additionalInformation';
import { createAppError } from 'utils/helpers';
import style from './FirmwareSettings.module.scss';

const FirmwareSettings: React.FC = () => {
	const { showLoader, hideLoader, setUploadProgress, addAppError } = useContext<IAppContext>(AppContext);
	const { changeFileData, typeSelectedFirmware, fileData } =
		useContext<ICreateFirmwareContext>(CreateFirmwareContext);
	const { isShowValidationError, validationErrorMessage } = useAdditionalValidation(
		fileData.fileId,
		'shouldUploadFirmware',
		'FirmwareSettings',
	);

	const sendForm = useCallback(async (file: File, callback: (value: string) => void) => {
		showLoader();
		const formData = new FormData();
		formData.append('file', file, file.name);
		try {
			const { data } = await postMediaFile({
				data: formData,
				config: {
					onUploadProgress: (progressEvent) => {
						const progress =
							progressEvent.total != null
								? Math.round((progressEvent.loaded * 100) / progressEvent.total)
								: 0;
						setUploadProgress(progress);
					},
				},
			});
			changeFileData({ fileId: data.fileId, fileHash: data.fileHash, fileName: file.name });
			callback(file.name);
			hideLoader();
		} catch (err) {
			hideLoader();
			const error = err as Error;
			const appError = createAppError(error);
			addAppError(appError);
		}
	}, []);

	const resetFile = useCallback(() => {
		changeFileData({ fileId: '', fileHash: null, fileName: null });
	}, []);

	return (
		<div className={style.container} data-test="FirmwareSettings">
			<FileUploader
				fileType={typeSelectedFirmware === 1 ? 'zip' : 'bin'}
				onFileLoad={sendForm}
				onFileReset={resetFile}
				defaultFileName={fileData.fileName}
				id="file"
				label="uploadFirmwareButton"
				requiredValidationMessage={isShowValidationError ? validationErrorMessage : undefined}
				filePath={fileData.fileName}
			/>
		</div>
	);
};

export default FirmwareSettings;
